// @flow

import gql from 'graphql-tag';

const appDirectoryFeaturesQuery = gql`
  query appDirectoryFeaturesQuery($slug: String!) {
    appBySlug(slug: $slug) {
      id
      image
      name
      slug
      isUpcoming
      inviteUrl

      currentImplementation {
        id
      }

      appAlternatives {
        totalCount
      }

      reviewPage {
        id
        lastChanged
        date
      }
    }

    appSupportNotes(appSlug: $slug) {
      id
    }
  }
`;

export default appDirectoryFeaturesQuery;
